import { api } from '@cma/app'
import {
  SetAccountSalesforceIdMutation,
  SetAccountSalesforceIdMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

// A dedicated mutation: the update-broker input is writable by account admins.
export function useSetAccountSalesforceId() {
  const queryClient = useQueryClient()
  return useMutation<
    SetAccountSalesforceIdMutation,
    Error,
    SetAccountSalesforceIdMutationVariables
  >(
    ({ input }) => {
      const query = gql`
        mutation SetAccountSalesforceId($input: SetAccountSalesforceIdInput!) {
          setAccountSalesforceId(input: $input) {
            account {
              id
              salesforceId
            }
            errors
          }
        }
      `
      const variables = { input }
      return api<SetAccountSalesforceIdMutation>({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries(['broker'])
      }
    }
  )
}
